module.exports = "<svg fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 0L7 1l5 6H0v2h12l-5 6 1 1 8-8-8-8z\" fill=\"currentColor\"></path></svg>"